{
  "contributionRebalance": "Start a new Contribution Rebalance",
  "driftRebalance": "Start a new Drift Rebalance",
  "table": {
    "createdAt": "Ran At",
    "state": "State",
    "files": "Files",
    "organization": "Organization"
  },
  "buyTradeFile": "Bulk Buys",
  "sellTradeFile": "Bulk Sells",
  "mutualFundTradeFile": "Mutual Fund Trades",
  "allocationFile": "Allocations",
  "ptfBulkTradeFile": "PTF Bulk Trade File"
}
